/**
 * Platform Detection Utilities
 *
 * Utilities for detecting the user's operating system
 * and providing platform-specific UI hints (e.g., keyboard shortcuts).
 */

/**
 * Detect if the user is on macOS, iPhone, or iPad
 */
export const isMac = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform);
};

/**
 * Get the platform-specific modifier key symbol
 * - macOS: ⌘ (Command)
 * - Windows/Linux: Ctrl
 */
export const getModifierKey = (): string => (isMac() ? 'Cmd' : 'Ctrl');

/**
 * Get the platform-specific modifier key name (for aria-labels)
 */
export const getModifierKeyName = (): string => (isMac() ? 'Command' : 'Control');
